import React from "react";
import PropTypes from "prop-types";
import { FormGroup as BaseFormGroup } from "reactstrap";

/*
 * reactstrap 9 targets Bootstrap 5, where .form-group no longer exists, so it
 * emits "mb-3" instead. This app runs Bootstrap 4 and the now-ui theme hangs
 * more than 160 rules off .form-group - most importantly the input padding in
 * `.form-group .form-control`, which is the only place that padding is set.
 *
 * The class is restored here rather than at each of the call sites. Check and
 * switch groups are left alone: those render .form-check, which is a different
 * Bootstrap 4 construct and never carried .form-group.
 */
function FormGroup({ className, ...props }) {
  const isCheck = props.check || props.switch;
  const merged = isCheck
    ? className
    : `form-group ${className || ""}`.trim();

  return <BaseFormGroup {...props} className={merged || undefined} />;
}

FormGroup.propTypes = {
  check: PropTypes.bool,
  className: PropTypes.string,
  switch: PropTypes.bool
};

export default FormGroup;
